import { Col, Row } from 'antd';
import React from 'react';

import styles from './index.less';

// eslint-disable-next-line react/display-name
const AndRow = React.memo(() => (
  <Row gutter={16}>
    <Col span={1} offset={10}>
      <span className={styles.andRow}>AND</span>
    </Col>
  </Row>
));

export default AndRow;
